module.exports = __webpack_public_path__ + "media/images/new-ui-images/insurance-icon-adc4bc068678112338c02729fd939200.svg";